"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var tasks;
        (function (tasks) {
            var calendar;
            (function (calendar_1) {
                class InitArgs {
                    constructor() {
                        this.users = [];
                        this.userGroups = [];
                        this.timeZones = [];
                        this.startOfCalendarWeek = 1;
                        this.tasksCalendar = appn.emptyString;
                        this.tasksCalendarData = appn.emptyString;
                        this.tasksCalendarEdit = appn.emptyString;
                        this.tasksEdit = appn.emptyString;
                        this.taskRecurringEdit = appn.emptyString;
                        this.taskTemplatesWizard1 = appn.emptyString;
                    }
                }
                class CalendarEdits {
                    constructor() {
                        this.maxSaveChanges = 5;
                        this.isInEditMode = false;
                        this.hasShownEditModeNotify = false;
                        this.items = [];
                    }
                    addItem(newEditItem) {
                        if (newEditItem)
                            this.items.push(newEditItem);
                        this.updateSaveButton();
                    }
                    hasUnsavedChanges() {
                        return this.items.length > 0 ? true : false;
                    }
                    clearItems() {
                        this.items = [];
                        this.updateSaveButton();
                    }
                    distinctTasks(draggingTaskId) {
                        const flags = new Array();
                        const output = new Array();
                        for (let i = 0; i < this.items.length; i++) {
                            if (flags[this.items[i].TaskId])
                                continue;
                            flags[this.items[i].TaskId] = true;
                            output.push(this.items[i].TaskId);
                        }
                        return draggingTaskId === undefined || flags[draggingTaskId] ? output.length : output.length + 1;
                    }
                    updateSaveButton() {
                        if (this.items.length === 0) {
                            $('#btn-Save').hide();
                            $('#btn-Cancel').hide();
                            $('#btn-AddNew').show();
                            $('.fc-daygrid-day-number,.fc-toolbar button,.fc-toolbar select,#ColorByStatus,#ColorByUser,#ColorByTemplateType').prop('disabled', false);
                            $('.fc-daygrid-day-number,.fc-toolbar button,.fc-toolbar select').removeClass('fc-state-disabled');
                            $('.fc-day-header').show();
                            this.isInEditMode = false;
                            this.hasShownEditModeNotify = false;
                            return;
                        }
                        this.isInEditMode = true;
                        $('#btn-Save').html(T('Save Changes') + ' <i class=" fa fa-save "></i>');
                        $('#btn-Save').show();
                        $('#btn-Cancel').show();
                        $('#btn-AddNew').hide();
                        $('.fc-daygrid-day-number,.fc-toolbar button,.fc-toolbar select,#ColorByStatus,#ColorByUser,#ColorByTemplateType').prop('disabled', true);
                        $('.fc-daygrid-day-number,.fc-toolbar button,.fc-toolbar select').addClass('fc-state-disabled');
                        $('.fc-day-header').hide();
                        if (!this.hasShownEditModeNotify) {
                            appn.toast.notify(appn.toast.Type.info, T('<b>Calendar is now in Edit Mode</b><br>Current view and filters are locked until you save or cancel your changes.'));
                            this.hasShownEditModeNotify = true;
                        }
                    }
                }
                let _initArgs;
                let _defaultView = {};
                calendar_1._isCanEditOrMoveMessageShowing = false;
                const _usersColorClasses = [];
                const _templateTypesColorClasses = [];
                let _calendarEdits;
                let _fcObject = {};
                let _fcView = {};
                let _fc = {};
                function init(args) {
                    _initArgs = args;
                    _calendarEdits = new CalendarEdits();
                    _defaultView = appn.sessionStorage.getItem('defaultCalendarView');
                    if (!_defaultView)
                        _defaultView = { viewName: 'dayGridMonth', viewDate: null };
                    addEvents();
                    appn.taskTemplateFilter.init();
                    setColorBy();
                    const calendarEl = document.getElementById('taskCalendar');
                    const options = new CalendarOptions('taskCalendar');
                    const calendar = new window.FullCalendar.Calendar(calendarEl, options);
                    calendar.render();
                }
                calendar_1.init = init;
                function addEvents() {
                    $('#clearParentTask').on('click', function (e) {
                        appn.location.navTo(_initArgs.tasksCalendar);
                    });
                    if ($('#ParentTaskId').val() !== undefined)
                        $(document).on('click', '.btn-resetFilters', function (e) {
                            appn.location.navTo(_initArgs.tasksCalendar);
                        });
                    $('.users-legend ul li').each(function (i, item) {
                        var _a, _b, _c;
                        const colorClasses = (_c = (_b = (_a = $(item)) === null || _a === void 0 ? void 0 : _a.attr('class')) === null || _b === void 0 ? void 0 : _b.split(' ')) !== null && _c !== void 0 ? _c : appn.emptyString;
                        for (let ix = 0; ix < colorClasses.length; ix++)
                            if (colorClasses[ix].indexOf('color-brand-') !== -1) {
                                _usersColorClasses.push({ userId: $(item).prop('id'), colorClass: colorClasses[ix] });
                                break;
                            }
                    });
                    $('.template-type-legend ul li').each(function (i, item) {
                        var _a, _b, _c;
                        const colorClasses = (_c = (_b = (_a = $(item)) === null || _a === void 0 ? void 0 : _a.attr('class')) === null || _b === void 0 ? void 0 : _b.split(' ')) !== null && _c !== void 0 ? _c : appn.emptyString;
                        for (let ix = 0; ix < colorClasses.length; ix++)
                            if (colorClasses[ix].indexOf('color-brand-') !== -1) {
                                _templateTypesColorClasses.push({ name: $(item).prop('id'), colorClass: colorClasses[ix] });
                                break;
                            }
                    });
                    $('#ColorByStatus,#ColorByUser,#ColorByTemplateType').off().on('change', function () {
                        const id = $(this).prop('id');
                        if (id === 'ColorByStatus')
                            setColorBy('statuses');
                        if (id === 'ColorByUser')
                            setColorBy('users');
                        if (id === 'ColorByTemplateType')
                            setColorBy('templateTypes');
                        getCalendarJsonDataFromServer();
                    });
                    $('#btn-Cancel').on('click', function () {
                        appn.dialog.confirm({
                            modalColor: 'modal-danger',
                            title: T('Discard Calendar Changes?'),
                            message: T('Your changes to {0} Task(s) will be lost...are you sure about this?<br><br>Hit <b>OK</b> to proceed.', _calendarEdits.distinctTasks()),
                            isDeleteAction: true,
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success'
                                }
                            },
                            callback: function (result) {
                                if (result) {
                                    _calendarEdits.clearItems();
                                    appn.location.reloadCurrentPage();
                                }
                            }
                        });
                    });
                    $('#btn-Save').off().on('click', function () {
                        submitCalendarEditsToServer();
                    });
                }
                function toggleManageBtn(isActive) {
                    if (isActive)
                        $('#manageBtn').attr('disabled', 'false');
                    else
                        $('#manageBtn').attr('disabled', appn.emptyString);
                }
                function showLoadingModalIfLargeDataQuery() {
                    appn.dialog.showLoading();
                }
                function getCalendarJsonDataFromServer() {
                    const view = _fcView;
                    const nameValues = [];
                    nameValues.push({ name: 'v', value: new Date().getTime().toString() });
                    const statusToFilterBy = appn.dataTable.getStateOrDefault('statusFilter', $('#statusFilter').val());
                    if (!statusToFilterBy.value || statusToFilterBy.value === 'All')
                        statusToFilterBy.value = '';
                    nameValues.push({ name: 'statusFilter', value: statusToFilterBy.value });
                    const userToFilterBy = appn.dataTable.getStateOrDefault('userFilter', $('#userFilter').val());
                    if (!userToFilterBy.value || userToFilterBy.value === 'All')
                        userToFilterBy.value = '';
                    nameValues.push({ name: 'userFilterId', value: userToFilterBy.value });
                    if (_initArgs.userGroups.length !== 0) {
                        const userGroupToFilterBy = appn.dataTable.getStateOrDefault('userGroupsFilter', $('#userGroupsFilter').val());
                        if (!userGroupToFilterBy.value || userGroupToFilterBy.value === 'All')
                            userGroupToFilterBy.value = appn.emptyString;
                        nameValues.push({ name: 'userGroupFilterId', value: userGroupToFilterBy.value });
                    }
                    const timeZoneToFilterBy = appn.dataTable.getStateOrDefault('timeZoneFilter', $('#timeZoneFilter').val());
                    if (!timeZoneToFilterBy.value || timeZoneToFilterBy.value === 'All')
                        timeZoneToFilterBy.value = '';
                    nameValues.push({ name: 'timeZoneId', value: timeZoneToFilterBy.value });
                    nameValues.push({ name: 'dateFilterFrom', value: view.dateProfile.currentRange.start.toISOString() });
                    nameValues.push({ name: 'dateFilterTo', value: view.dateProfile.currentRange.end.toISOString() });
                    nameValues.push({ name: 'templateId', value: appn.taskTemplateFilter.getStateOrDefault().value });
                    nameValues.push({ name: 'parentTaskId', value: $('#ParentTaskId').val() || '' });
                    const params = appn.location.buildQueryString(nameValues);
                    const url = _initArgs.tasksCalendarData + params;
                    showLoadingModalIfLargeDataQuery();
                    appn.ajax.post({
                        url: url,
                        dataType: 'json',
                        done: function (dataParsed, p1, p2, p3) {
                            ajaxPostDone(dataParsed, p1, p2, p3);
                        },
                        fail: function (p1, p2, p3) {
                            appn.dialog.alert({
                                modalColor: 'modal-danger',
                                title: T('Calendar Data Load Failed'),
                                message: T('Failed to load calendar data. Please sign out and sign in again. Contact support if this problem persists.'),
                                buttons: {
                                    ok: {
                                        label: '<span>' + T('OK') + '</span>',
                                        className: 'btn-success'
                                    }
                                },
                                autoHeaderIcon: false
                            });
                        },
                        always: function () {
                            appn.dialog.hideLoading();
                        }
                    });
                }
                calendar_1.getCalendarJsonDataFromServer = getCalendarJsonDataFromServer;
                function ajaxPostDone(dataParsed, p1, p2, p3) {
                    _fc.removeAllEvents();
                    const defaultStatusColorsParsed = JSON.parse(dataParsed.DefaultStatusColors);
                    const calendarEventsToRender = [];
                    if (dataParsed.TaskCalendarDataItems && dataParsed.TaskCalendarDataItems.length > 0)
                        for (let i = 0; i < dataParsed.TaskCalendarDataItems.length; i++) {
                            let colorToAdd = '';
                            let colorClassToAdd = '';
                            const colorBy = $('#ColorByStatus').prop('checked') === true ? 'statuses' : 'users';
                            if ($('#ColorByStatus').prop('checked')) {
                                dataParsed.TaskCalendarDataItems[i].UserColorCode = appn.emptyString;
                                if (!dataParsed.TaskCalendarDataItems[i].IsTaskRecurring) {
                                    const status = dataParsed.TaskCalendarDataItems[i].Status.trim().toLowerCase();
                                    let statusToCompare = status;
                                    if (dataParsed.TaskCalendarDataItems[i].CustomStatus)
                                        statusToCompare = dataParsed.TaskCalendarDataItems[i].CustomStatus.trim().toLowerCase();
                                    if (statusToCompare)
                                        for (let j = 0; j < dataParsed.MergedStatuses.length; j++) {
                                            if (!dataParsed.MergedStatuses[j].Color || !dataParsed.MergedStatuses[j].Color.trim())
                                                break;
                                            if (dataParsed.MergedStatuses[j].Value.trim().toLowerCase() === statusToCompare) {
                                                colorToAdd = dataParsed.MergedStatuses[j].Color;
                                                break;
                                            }
                                        }
                                    if (!colorToAdd)
                                        colorToAdd = defaultStatusColorsParsed[dataParsed.TaskCalendarDataItems[i].Status];
                                }
                            }
                            if ($('#ColorByUser').prop('checked'))
                                $(_usersColorClasses).each(function (ii, item) {
                                    if (item.userId === dataParsed.TaskCalendarDataItems[i].AppUserId) {
                                        if (item.colorClass)
                                            colorClassToAdd = item.colorClass;
                                        return false;
                                    }
                                });
                            if ($('#ColorByTemplateType').prop('checked')) {
                                dataParsed.TaskCalendarDataItems[i].UserColorCode = appn.emptyString;
                                $(_templateTypesColorClasses).each(function (ii, item) {
                                    if (item.name === dataParsed.TaskCalendarDataItems[i].TemplateName) {
                                        colorClassToAdd = item.colorClass;
                                        return false;
                                    }
                                });
                            }
                            const eventTitle = `${dataParsed.TaskCalendarDataItems[i].AssignedTo} - ${dataParsed.TaskCalendarDataItems[i].TaskName}`;
                            calendarEventsToRender.push({
                                id: dataParsed.TaskCalendarDataItems[i].Id,
                                groupId: dataParsed.TaskCalendarDataItems[i].TaskId,
                                allDay: dataParsed.TaskCalendarDataItems[i].IsAllDay,
                                start: dataParsed.TaskCalendarDataItems[i].Start,
                                end: dataParsed.TaskCalendarDataItems[i].End,
                                startStr: window.moment(dataParsed.TaskCalendarDataItems[i].Start).toISOString(),
                                endStr: window.moment(dataParsed.TaskCalendarDataItems[i].End).toISOString(),
                                title: eventTitle,
                                url: '#',
                                classNames: [],
                                editable: dataParsed.TaskCalendarDataItems[i].CanEditOrMove,
                                startEditable: dataParsed.TaskCalendarDataItems[i].CanEditOrMove,
                                durationEditable: dataParsed.TaskCalendarDataItems[i].CanEditOrMove,
                                resourceEditable: false,
                                display: 'block',
                                overlap: true,
                                constraint: {},
                                backgroundColor: colorToAdd,
                                borderColor: colorToAdd,
                                textColor: '',
                                extendedProps: {
                                    parentId: dataParsed.TaskCalendarDataItems[i].ParentId,
                                    taskStatus: dataParsed.TaskCalendarDataItems[i].Status,
                                    taskType: dataParsed.TaskCalendarDataItems[i].TemplateName,
                                    isRecurring: dataParsed.TaskCalendarDataItems[i].IsTaskRecurring,
                                    startBy: dataParsed.TaskCalendarDataItems[i].StartBy,
                                    completeBy: dataParsed.TaskCalendarDataItems[i].CompleteBy,
                                    templateName: dataParsed.TaskCalendarDataItems[i].TemplateName,
                                    additionalInfo: dataParsed.TaskCalendarDataItems[i].AdditionalInfo,
                                    recurringTaskName: dataParsed.TaskCalendarDataItems[i].RecurringTaskName,
                                    taskRecurringId: dataParsed.TaskCalendarDataItems[i].TaskRecurringId,
                                    taskId: dataParsed.TaskCalendarDataItems[i].TaskId,
                                    taskName: dataParsed.TaskCalendarDataItems[i].TaskName,
                                    completeAtText: dataParsed.TaskCalendarDataItems[i].CompleteAtText,
                                    completeAtLat: dataParsed.TaskCalendarDataItems[i].CompleteAtLat,
                                    completeAtLon: dataParsed.TaskCalendarDataItems[i].CompleteAtLon,
                                    canEditOrMoveMessage: dataParsed.TaskCalendarDataItems[i].CanEditOrMoveMessage,
                                    assignedToId: dataParsed.TaskCalendarDataItems[i].AssignedToId,
                                    userColorCode: dataParsed.TaskCalendarDataItems[i].UserColorCode,
                                    colorClass: colorClassToAdd,
                                    flashMe: false,
                                    hasBeenMoved: false
                                },
                                source: null
                            });
                        }
                    _fc.batchRendering(function () {
                        calendarEventsToRender.forEach((event) => {
                            _fc.addEvent(event, true);
                        });
                    });
                    $('#taskCalendar .appn-calendar-filters').remove();
                    $('#taskCalendar .fc-toolbar.fc-header-toolbar').after(`<div class="appn-calendar-filters"></div>`);
                    $('#taskCalendar .appn-calendar-filters').append(`${appn.elementBuilder.buildSelect(_initArgs.timeZones, 'timeZoneFilter', 'saveMeState')}`);
                    if (_initArgs.userGroups.length !== 0)
                        $('#taskCalendar .appn-calendar-filters').append(`${appn.elementBuilder.buildSelect(_initArgs.userGroups, 'userGroupsFilter', 'saveMeState')}`);
                    $('#taskCalendar .appn-calendar-filters').append(`${appn.elementBuilder.buildSelect(_initArgs.users, 'userFilter', 'saveMeState select2-noinit')}`);
                    $('#taskCalendar .appn-calendar-filters').append(`${appn.elementBuilder.buildTaskStatusSelect(dataParsed.MergedStatuses, 'statusFilter', 'saveMeState')}`);
                    $('.statuses-legend ul li').remove();
                    let statusesToAddLegend = '';
                    for (let i = 0; i < dataParsed.MergedStatuses.length; i++)
                        statusesToAddLegend += `<li style="background-color: ${dataParsed.MergedStatuses[i].Color};" role="presentation" class="folder " id="${dataParsed.MergedStatuses[i].Value}">` +
                            `<span class="text-whitesmoke" id="">${dataParsed.MergedStatuses[i].Display}</span></li>`;
                    $('.statuses-legend ul').append(statusesToAddLegend);
                    appn.sideFilterAndContent.appendShowButton($('#taskCalendar .appn-calendar-filters'));
                    appn.actionButtons.renderNavbarActionButtons([
                        {
                            buttonId: 'addnew',
                            buttonType: 'AddNew'
                        }
                    ], appn.requestUser.isUserOrHigher);
                    $('#addnew').off().on('click', function (e) {
                        e.preventDefault();
                        appn.tasks.showAddNewDialog(false, false, undefined, undefined, false, T('Calendar'));
                    });
                    appn.saveMeState.init(function () {
                        getCalendarJsonDataFromServer();
                    }, function () {
                        setColorBy('users');
                        appn.sessionStorage.removeItem('defaultCalendarView');
                        const view = _fcView.getCurrentData();
                        if (view.currentViewType === ViewSpecs.dayGridMonth)
                            getCalendarJsonDataFromServer();
                        else
                            _fc.changeView(ViewSpecs.dayGridMonth, _defaultView.viewDate);
                    }, '#taskCalendar .appn-calendar-filters');
                    appn.select.init();
                    appn.select.init({ selector: '#userFilter', minimumResultsForSearch: '25' });
                    appn.dialog.hideLoading();
                }
                function setColorBy(colorBy) {
                    if (!colorBy) {
                        colorBy = appn.localStorage.getItem('defaultColorBy');
                        if (!colorBy)
                            colorBy = 'users';
                    }
                    appn.localStorage.setItem('defaultColorBy', colorBy);
                    if (colorBy === 'statuses') {
                        $('#ColorByStatus').prop('checked', true);
                        $('#ColorByUser').prop('checked', false);
                        $('#ColorByTemplateType').prop('checked', false);
                    }
                    if (colorBy === 'users') {
                        $('#ColorByUser').prop('checked', true);
                        $('#ColorByStatus').prop('checked', false);
                        $('#ColorByTemplateType').prop('checked', false);
                    }
                    if (colorBy === 'templateTypes') {
                        $('#ColorByTemplateType').prop('checked', true);
                        $('#ColorByStatus').prop('checked', false);
                        $('#ColorByUser').prop('checked', false);
                    }
                }
                function submitCalendarEditsToServer() {
                    appn.dialog.showLoading();
                    const timeZoneToFilterBy = appn.dataTable.getStateOrDefault('timeZoneFilter', $('#timeZoneFilter').val());
                    if (!timeZoneToFilterBy.value || timeZoneToFilterBy.value === 'All')
                        timeZoneToFilterBy.value = '';
                    appn.ajax.post({
                        url: _initArgs.tasksCalendarEdit,
                        dataType: 'json',
                        data: { TaskCalendarEditItems: _calendarEdits.items, TimeZoneId: timeZoneToFilterBy.value },
                        always: function (dataParsed, p1, p2, p3) {
                            _calendarEdits.clearItems();
                            getCalendarJsonDataFromServer();
                            appn.dialog.hideLoading();
                            appn.toast.notify(appn.toast.Type.info, T('Your changes were saved successfully.'));
                        },
                        fail: function (p1, p2, p3) {
                            appn.dialog.hideLoading();
                            appn.dialog.alert({
                                modalColor: 'modal-danger',
                                title: T('Calendar Edit Failed'),
                                message: T('Failed to save changes to calendar data.'),
                                buttons: {
                                    ok: {
                                        label: '<span>' + T('OK') + '</span>',
                                        className: 'btn-success'
                                    }
                                },
                                callback: function (result) {
                                    appn.location.reloadCurrentPage();
                                }
                            });
                        }
                    });
                }
                function addItemEvents(event, modal) {
                    $(modal).on('click', 'button[value="Details"]', function (e) {
                        e.preventDefault();
                        const isrecur = event.extendedProps.isRecurring;
                        if (isrecur)
                            appn.location.navTo(_initArgs.tasksEdit, [
                                { name: 'taskRecurringId', value: event.extendedProps.taskRecurringId },
                                { name: 'returnAction', value: 'Calendar' }
                            ]);
                        else
                            appn.location.navTo(_initArgs.tasksEdit, [
                                { name: 'id', value: event.id },
                                { name: 'returnAction', value: 'Calendar' }
                            ]);
                    });
                    $(modal).on('click', 'button[value="Schedule"]', function (e) {
                        e.preventDefault();
                        appn.location.navTo(_initArgs.taskRecurringEdit, [
                            { name: 'id', value: event.extendedProps.taskRecurringId },
                            { name: 'returnAction', value: 'Calendar' }
                        ]);
                    });
                    $(modal).on('click', 'button[value="Children"]', function (e) {
                        e.preventDefault();
                        appn.location.navTo(_initArgs.tasksCalendar, [
                            {
                                name: 'parentTaskId',
                                value: event.extendedProps.parentId
                            }
                        ]);
                    });
                }
                function newEditItem(calendarEditAction, fcEvent) {
                    return {
                        CalendarEditAction: calendarEditAction,
                        TaskId: fcEvent.extendedProps.taskId,
                        IsAllDay: fcEvent.allDay,
                        TimeStamp: new Date().getTime(),
                        Start: window.moment(fcEvent.start).format('YYYY-MM-DD HH:mm:ss'),
                        End: fcEvent.end ? window.moment(fcEvent.end).format('YYYY-MM-DD HH:mm:ss') : null
                    };
                }
                function showInEditModeNotify() {
                    if (_calendarEdits.isInEditMode) {
                        appn.toast.notify(appn.toast.Type.error, T('Your action was blocked because the calendar is currently in Edit mode.<br><br>Hit Save to keep your changes or discard them by hitting Cancel.'));
                        return true;
                    }
                    return false;
                }
                class CalendarOptions {
                    constructor(parentId) {
                        this.headerToolbar = {
                            start: 'prev,next today',
                            center: 'title',
                            end: `${ViewSpecs.dayGridMonth},${ViewSpecs.timeGridWeek},${ViewSpecs.timeGridDay},${ViewSpecs.listWeek}`
                        };
                        this.aspectRatio = 2;
                        this.businessHours = false;
                        this.firstDay = 0;
                        this.handleWindowResize = true;
                        this.height = '100%';
                        this.initialDate = _defaultView.viewDate;
                        this.initialView = _defaultView.viewName;
                        this.locale = 'en-GB';
                        this.navLinks = true;
                        this.showNonCurrentDates = true;
                        this.themeSystem = 'bootstrap';
                        this.timeZone = 'local';
                        this.windowResizeDelay = 25;
                        this.datesSet = function (dateInfo) {
                            _fcObject = dateInfo;
                            _fcView = _fcObject.view.getCurrentData();
                            _fc = _fcObject.view.calendar;
                            appn.views.tasks.calendar.getCalendarJsonDataFromServer();
                            appn.sessionStorage.setItem('defaultCalendarView', {
                                viewName: dateInfo.view.type,
                                viewDate: window.moment(_fcView.currentDate).format('YYYY-MM-DD')
                            });
                        };
                        this.navLinkDayClick = function (date, jsEvent) {
                            if (_calendarEdits.isInEditMode)
                                return false;
                            _fc.changeView(ViewSpecs.timeGridDay, date);
                        };
                        this.viewDidMount = function (view) {
                            _fcObject = view;
                            _fcView = _fcObject.view.getCurrentData();
                            _fc = _fcObject.view.calendar;
                        };
                        this.windowResize = function (arg) {
                            arg.view.calendar.setOption('aspectRatio', getParentAspectRatio($(_fc.el).attr('id')));
                            arg.view.calendar.render();
                        };
                        this.dayMaxEventRows = true;
                        this.editable = true;
                        this.eventDurationEditable = true;
                        this.eventStartEditable = true;
                        this.eventTimeFormat = {
                            hour: '2-digit',
                            minute: '2-digit',
                            meridiem: false,
                            hour12: false
                        };
                        this.selectMirror = true;
                        this.selectable = false;
                        this.slotLabelFormat = {
                            hour: '2-digit',
                            minute: '2-digit',
                            meridiem: false,
                            hour12: false
                        };
                        this.dateClick = function (dateClickedOn, event) {
                        };
                        this.eventAdd = function (addInfo) {
                        };
                        this.eventAllow = function (dropLocation, draggedEvent) {
                            if (!draggedEvent.durationEditable || (draggedEvent.editable && !draggedEvent.editable) || !draggedEvent.startEditable) {
                                if (!appn.views.tasks.calendar._isCanEditOrMoveMessageShowing)
                                    appn.toast.notify(appn.toast.Type.error, draggedEvent.extendedProps.canEditOrMoveMessage);
                                appn.views.tasks.calendar._isCanEditOrMoveMessageShowing = true;
                                return false;
                            }
                            if (_calendarEdits.maxSaveChanges < _calendarEdits.distinctTasks(draggedEvent.extendedProps.taskId)) {
                                if (!appn.views.tasks.calendar._isCanEditOrMoveMessageShowing)
                                    appn.toast.notify(appn.toast.Type.error, T('<b>Maximum Calendar Changes Reached</b>') + '<br>' +
                                        T(`You can't change more than {0} Tasks in an editing session.`, _calendarEdits.maxSaveChanges) + '<br>' +
                                        T('Hit Save or Cancel to apply/discard your current changes.'));
                                appn.views.tasks.calendar._isCanEditOrMoveMessageShowing = true;
                                return false;
                            }
                            return true;
                        };
                        this.eventClick = function (eventInfo, jsEvent, view) {
                            if (!eventInfo.event)
                                return;
                            const event = eventInfo.event;
                            if (event.extendedProps.isRecurring) {
                                const buttonConfig = {};
                                buttonConfig.schedule = {
                                    label: T('Schedule'),
                                    className: 'btn-info',
                                    callback: function () {
                                        appn.location.navTo(`${_initArgs.taskRecurringEdit}/${event.id}`, [
                                            {
                                                name: 'bk',
                                                value: 'Calendar_Tasks'
                                            }
                                        ]);
                                        return true;
                                    }
                                };
                                buttonConfig.details = {
                                    label: '<span>' + T('Details') + '</span>',
                                    className: 'btn-success',
                                    callback: function () {
                                        appn.location.navTo(_initArgs.tasksEdit, [
                                            { name: 'taskRecurringId', value: event.id },
                                            { name: 'bk', value: 'Calendar_Tasks' }
                                        ]);
                                        return true;
                                    }
                                };
                                const modalContent = `<div><div class="form-group">` +
                                    `<label class="col-form-label col-sm-4">${T('Recurring Task')}</label>` +
                                    `<div class="col-sm-8">` +
                                    `<label class="col-form-label">${event.extendedProps.recurringTaskName}</label>` +
                                    `</div></div>` +
                                    `<div class="form-group ${event.extendedProps.templateName ? '' : 'hide'}">` +
                                    `<label class="col-form-label col-sm-4">${T('Template')}</label>` +
                                    `<div class="col-sm-8">` +
                                    `<label class="col-form-label">${event.extendedProps.templateName}</label>` +
                                    `</div></div>` +
                                    `<div class="form-group">` +
                                    `<label class="col-form-label col-sm-4">${T('Start By')}</label>` +
                                    `<label class="col-form-label col-sm-8">${event.extendedProps.startBy}</label>` +
                                    `<label class="col-form-label col-sm-4">${T('Complete By')}</label>` +
                                    `<label class="col-form-label col-sm-8">${event.extendedProps.completeBy}</label>` +
                                    `</div>` +
                                    `<div class="form-group ${event.allDay ? '' : 'hide'}">` +
                                    `<label class="col-form-label col-sm-4">${T('All Day')}</label>` +
                                    `<div class="col-sm-8">` +
                                    `<label class="col-form-label"><i class="fa fa-check"></i></label>` +
                                    `</div></div>` +
                                    `<div class="form-group ${event.extendedProps.additionalInfo ? '' : 'hide'}">` +
                                    `<label class="col-form-label col-sm-4">${T('Additional Info')}</label>` +
                                    `<div class="col-sm-5">` +
                                    `<label class="col-form-label">${event.extendedProps.additionalInfo}</label>` +
                                    `</div></div></div>`;
                                appn.dialog.custom({
                                    message: modalContent,
                                    title: `${event.title}`,
                                    modalColor: 'modal-info',
                                    closeButton: true,
                                    buttons: !_calendarEdits.isInEditMode ? buttonConfig : null
                                });
                            }
                            else {
                                const queryString = appn.location.buildQueryString([
                                    { name: 'id', value: event.id },
                                    { name: 'taskRecurringId', value: '' },
                                    { name: 'isLoadingIframe', value: 'true' },
                                    { name: 'returnAction', value: 'Calendar' }
                                ]);
                                appn.iframe.openModal({
                                    url: `${_initArgs.tasksEdit}/${queryString}`,
                                    size: 'modal-xl'
                                }).then(function (modal) {
                                    modal.on('hidden.bs.modal', function () {
                                        appn.location.reloadCurrentPage();
                                    });
                                    addItemEvents(event, modal);
                                });
                            }
                        };
                        this.eventDidMount = function (addInfo) {
                            const $cachedElement = $(addInfo.el);
                            $cachedElement.find('.fc-event-title').addClass('text-truncate');
                            $cachedElement.find('.fc-event-time').css('min-width', '2.5rem');
                            if (addInfo.event) {
                                const event = addInfo.event;
                                if (event.extendedProps.isRecurring) {
                                    $cachedElement.css('opacity', '0.3');
                                    $cachedElement.find('.fc-title').prepend('<i class="fa fa-repeat"></i>&nbsp;');
                                }
                                if (event.extendedProps.colorClass)
                                    $cachedElement.addClass(event.extendedProps.colorClass);
                                if (event.extendedProps.userColorCode)
                                    $cachedElement.attr('style', `background-color:${event.extendedProps.userColorCode}; border-color:${event.extendedProps.userColorCode}`);
                                if (event.extendedProps.flashMe && _calendarEdits.hasUnsavedChanges())
                                    $cachedElement.addClass('flash-success');
                            }
                        };
                        this.eventOverlap = function (stillEvent, movingEvent) {
                            return true;
                        };
                        this.eventResize = function (eventResizeInfo) {
                            const event = eventResizeInfo.event;
                            if (window.moment(event.start).isBefore(window.moment().startOf('day'))) {
                                appn.dialog.confirm({
                                    modalColor: 'modal-info',
                                    title: T('Change Task Occurring in the Past?'),
                                    message: T('This Task is configured to occur in the past.<br>Are you sure you want to continue changing it?<br><br>Hit <b>OK</b> to proceed.'),
                                    isDeleteAction: true,
                                    buttons: {
                                        confirm: {
                                            label: '<span>' + T('OK') + '</span>',
                                            className: 'btn-success'
                                        }
                                    },
                                    callback: function (result) {
                                        if (result)
                                            _calendarEdits.addItem(newEditItem('EditResized', event));
                                        else
                                            eventResizeInfo.revert();
                                    }
                                });
                                return;
                            }
                            _calendarEdits.addItem(newEditItem('EditResized', event));
                        };
                        this.eventResizeStart = function (event, jsEvent, ui, view) {
                        };
                        this.eventResizeStop = function (event, jsEvent, ui, view) {
                        };
                        this.events = [];
                        this.eventsSet = function (events) {
                        };
                        this.select = function (start, end) {
                            const isInEditMode = showInEditModeNotify();
                            if (isInEditMode)
                                return false;
                            const allDay = !start.hasTime() && !end.hasTime();
                            if (start.isBefore(window.moment().startOf('day')))
                                appn.dialog.confirm({
                                    modalColor: 'modal-info',
                                    title: T('Create Task in the Past?'),
                                    message: T('Are you sure you want to create a Task in the past?') + '<br><br>' +
                                        T('<b>Start By: </b>{0}<br><b>Complete By: </b>{1}', start.toISOString(), end.toISOString()) + '<br><br>' +
                                        T('Hit<b>OK</b> to create this Task now.'),
                                    isDeleteAction: true,
                                    buttons: {
                                        confirm: {
                                            label: '<span>' + T('OK') + '</span>',
                                            className: 'btn-success'
                                        }
                                    },
                                    callback: function (result) {
                                        if (result)
                                            appn.tasks.showAddNewDialog(false, true, start.toISOString(), end.toISOString(), allDay);
                                    }
                                });
                            else
                                appn.dialog.confirm({
                                    modalColor: 'modal-info',
                                    title: T('Create New Task'),
                                    message: T('<b>Start By: </b>{0}<br><b>Complete By: </b>{1}', start.toISOString(), end.toISOString()) + '<br><br>' +
                                        T('Hit<b>OK</b> to create this Task now.'),
                                    buttons: {
                                        confirm: {
                                            label: '<span>' + T('OK') + '</span>',
                                            className: 'btn-success'
                                        }
                                    },
                                    callback: function (result) {
                                        if (result)
                                            appn.tasks.showAddNewDialog(false, true, start.toISOString(), end.toISOString(), allDay);
                                    }
                                });
                        };
                        this.dragRevertDuration = 250;
                        this.dragScroll = true;
                        this.droppable = false;
                        this.drop = function (dropInfo) {
                            if ($('#drop-remove').is(':checked'))
                                $(dropInfo.draggedEl).remove();
                        };
                        this.eventDragStart = function (event, jsEvent, ui, view) {
                        };
                        this.eventDragStop = function (event, jsEvent, ui, view) {
                            appn.views.tasks.calendar._isCanEditOrMoveMessageShowing = false;
                        };
                        this.eventDrop = function (info) {
                            if (!info.event)
                                return;
                            const event = info.event;
                            if (window.moment(event.start).isBefore(window.moment().startOf('day')))
                                appn.dialog.confirm({
                                    modalColor: 'modal-info',
                                    title: T('Change Task Occurring in the Past?'),
                                    message: T('This Task is configured to occur in the past.<br>Are you sure you want to continue changing it?<br><br>Hit <b>OK</b> to proceed.'),
                                    isDeleteAction: true,
                                    buttons: {
                                        confirm: {
                                            label: '<span>' + T('OK') + '</span>',
                                            className: 'btn-success'
                                        }
                                    },
                                    callback: function (result) {
                                        if (result)
                                            _calendarEdits.addItem(newEditItem('EditMoved', event));
                                        else
                                            info.revert();
                                    }
                                });
                            else
                                info.event.setExtendedProp('hasBeenMoved', true);
                            _calendarEdits.addItem(newEditItem('EditMoved', event));
                            Object.assign(event.extendedProps.flashMe, _calendarEdits.hasUnsavedChanges());
                        };
                        this.bootstrapFontAwesome = {
                            close: 'fa-times',
                            prev: 'fa-chevron-left',
                            next: 'fa-chevron-right',
                            prevYear: 'fa-angle-double-left',
                            nextYear: 'fa-angle-double-right'
                        };
                        this.aspectRatio = getParentAspectRatio(parentId);
                    }
                }
                let ViewSpecs;
                (function (ViewSpecs) {
                    ViewSpecs["dayGrid"] = "dayGrid";
                    ViewSpecs["dayGridDay"] = "dayGridDay";
                    ViewSpecs["dayGridMonth"] = "dayGridMonth";
                    ViewSpecs["dayGridWeek"] = "dayGridWeek";
                    ViewSpecs["list"] = "list";
                    ViewSpecs["listDay"] = "listDay";
                    ViewSpecs["listMonth"] = "listMonth";
                    ViewSpecs["listWeek"] = "listWeek";
                    ViewSpecs["listYear"] = "listYear";
                    ViewSpecs["timeGrid"] = "timeGrid";
                    ViewSpecs["timeGridDay"] = "timeGridDay";
                    ViewSpecs["timeGridWeek"] = "timeGridWeek";
                })(ViewSpecs || (ViewSpecs = {}));
                function getParentAspectRatio(parentId) {
                    var _a, _b, _c;
                    const height = (_a = Number($(`#${parentId}`).closest('.card-body').css('min-height').replace('px', ''))) !== null && _a !== void 0 ? _a : 800;
                    const width = (_b = $(`#${parentId}`).closest('.card-body').outerWidth()) !== null && _b !== void 0 ? _b : 1000;
                    const heightOffset = 5 + ((_c = $('.fc-header-toolbar').outerHeight()) !== null && _c !== void 0 ? _c : 83);
                    const widthOffset = Number($(`#${parentId}`).closest('.card-body').css('padding-left').replace('px', '')) + Number($(`#${parentId}`).closest('.card-body').css('padding-right').replace('px', ''));
                    const marginNeededBelowCard = 10;
                    return (width - widthOffset) / (height - (heightOffset + marginNeededBelowCard));
                }
            })(calendar = tasks.calendar || (tasks.calendar = {}));
        })(tasks = views.tasks || (views.tasks = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
